export function humanReadableDate(value: number | undefined, format: 'full' | 'hour') {
    if (value === null || value === undefined) {
        return 'N/A';
    } else {
        // transform timestamp in milliseconds if it's in seconds
        value = value / Math.pow(10, 12) > 1 ? value : value * 1000;
        const date = new Date(value);
        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = pad(date.getFullYear());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        const hourDate = `${hours}:${minutes}:${seconds}`;
        if (format === 'full') {
            return `${day}/${month}/${year} ${hourDate}`;
        } else if (format === 'hour') {
            return hourDate;
        }
    }
}

function pad(number: number) {
    return String(number).padStart(2, '0');
}
